<script>
  import { tappables } from '../stores'
  import PointUpAndBounce from '../gestures/PointUpAndBounce.svelte'
  const states = [{ el: $tappables.buy, rotation: 0 }]
</script>

<PointUpAndBounce {states} type="simple" on:end on:event />
